import { Html } from "@react-three/drei";
import { motion } from "framer-motion-3d";

export function CityName (props) {
    const { name } = props;

    return (
        <motion.group 
            initial={{y:[0]}} 
            animate={{y:[0,1]}}
            >
            <Html 
                center
                key={name + "-city"}
                position={[0,2,0]}
                >
                <div className="information">
                    {name}
                </div>
            </Html>
        </motion.group>
    )
}